import { reducerTypes } from "./types";
import { ICollections, ICollectionProducts } from "../../interfaces/collections";

export const getAllCollectionsAction = (data: ICollections[]) => ({
  type: reducerTypes.GET_ALL_COLLECTIONS,
  payload: data,
});

export const getCollectionAction = (data: ICollectionProducts[]) => ({
  type: reducerTypes.GET_COLLECTION,
  payload: data,
});
